"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Skeleton = _interopRequireDefault(require("../Skeleton"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SkeletonText = function SkeletonText(_a) {
  var count = _a.count,
      _b = _a.height,
      height = _b === void 0 ? '16px' : _b,
      _c = _a.width,
      width = _c === void 0 ? [1] : _c;
  return _react.default.createElement(_Skeleton.default, {
    count: count,
    height: height,
    width: width
  });
};

var _default = SkeletonText;
exports.default = _default;